import { Button, styled, Theme, Typography } from '@material-ui/core';
import { relative } from 'path';
import { COLORS } from 'shared/constants/COLORS';

export const Container = styled('div')(({ theme }) => ({
  width: '100%',
  height: '100%',
  borderRadius: 8,
  padding: 30,
  // border: '1px solid #2d343e',
  border: '1px solid',
  borderColor: theme.palette.type === 'dark' ? COLORS.DARK_BORDER : COLORS.LIGHT_BORDER,
  background: theme.palette.type === 'dark' ? '#0b0f14' : COLORS.WHITE,
}));

export const FlexContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',

  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 10,
  },
}));

export const CustomButton = styled(Button)({
  background: 'transparent',
  border: '1px solid',
  borderColor: COLORS.PRIMARY,
  height: 46,
  maxWidth: 171,
  '&.Mui-disabled': {
    opacity: 0.2,
  },
});

export const CustomBar = styled('div')<Theme, { percentage?: number }>(({ percentage = 0, theme }) => ({
  background: theme.palette.type === 'dark' ? '#222b36' : COLORS.LIGHT_BORDER,
  height: 25,
  borderRadius: 5,
  margin: '20px 0',
  position: 'relative',

  '&::before': {
    content: '""',
    width: percentage + '%',
    height: 25,
    borderRadius: 5,
    backgroundImage:
      percentage > 50
        ? 'linear-gradient(91deg, #04aa69 0%, #007e54 100%)'
        : percentage > 25
          ? 'linear-gradient(93deg, #f49322 0%, #cd7b1b 100%)'
          : 'linear-gradient(99deg, #bd2626 0%, #ac1616)',
    position: 'absolute',
  },
}));

export const CustomText = styled(Typography)(({ theme, size }: any) => ({
  fontSize: size || 16,
  color: theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.BLACK,
}));
